// Stub: will be replaced by real API calls
export const mockGeneralSettings: any = {};
export const mockPaymentIntegrations: any[] = [];
export const mockEmailSettings: any = {};
export const mockSmsSettings: any = {};
export const mockSecuritySettings: any = {};
export const mockNotificationSettings: any = {};
export const mockBackupSettings: any = {};
export const mockBackupHistory: any[] = [];
export const mockApiSettings: any = {};
